import React, { Component } from 'react'
import Ink from 'react-ink';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

class ConfigurationModalValueButton extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    this.props.callback(this.props.stepId, this.props.id);
  }

  render() {
    let icon = 'icon circle thin';
    if (this.props.selected || this.props.selectedInOtherStep) {
      icon = 'green icon check circle';
    }

    return (
      <button className="configurationModalStepValueButton" onClick={this.onClick}>
        <i className={icon}>&nbsp;</i>
        <label className="stepName">{this.props.description}</label>
        <Ink />
      </button>
    )
  }
}

ConfigurationModalValueButton.propTypes = {
  description: PropTypes.string,
  selected: PropTypes.bool,
  callback: PropTypes.func,
  stepId: PropTypes.number,
  selectedInOtherStep: PropTypes.bool
}
function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, { })(ConfigurationModalValueButton)



// WEBPACK FOOTER //
// src/components/ConfigurationModalValueButton.jsx